

















































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import backNav from '@/components/nav/BackNav.vue';
import {
  Button, Message, Radio, RadioGroup, Scrollbar,
} from 'element-ui';
import NProgress from 'nprogress';
// png
import obtainIcon1 from '@/assets/images/obtainIcon1.png';
import obtainIcon2 from '@/assets/images/obtainIcon2.png';
import obtainIcon3 from '@/assets/images/obtainIcon3.png';
import Vocabulary from '@/servers/modules/vocabulary/vocabulary'; // server
import Read from '@/servers/modules/read/read'; // server
import VuePlyr from 'vue-plyr';
import { Howl, Howler } from 'howler';
// 倒计时
import moment from 'moment';
import fa from 'element-ui/src/locale/lang/fa';

    @Component({
      components: {
        backNav,
        Button,
        Radio,
        Scrollbar,
        RadioGroup,
        VuePlyr,
      },
    })
export default class extends Vue {
    private audioUrl:any = '';

    @Getter public bcgLeftBlock :any;

    @Getter public basicData :any;

    @Getter public skeleton: any;

    @Mutation public setSkeletonDescribe;

    // 放大缩小字体
    private reSize : any = { fontSize: 18, lageColor: '#333333', smallColor: '#333333' };

    private reSizeFun(type:string) {
      const _this = this;
      // 初始化颜色
      this.reSize.lageColor = this.reSize.smallColor = '#333333';
      if (type == 'small') {
        this.reSize.fontSize = this.reSize.fontSize - 2; reSize();
      }
      if (type == 'lage') {
        this.reSize.fontSize = this.reSize.fontSize + 2; reSize();
      }
      function reSize() {
        if (_this.reSize.fontSize <= 14) {
          _this.reSize.fontSize = 14;
          _this.reSize.smallColor = '#B4B4B4';
        }
        if (_this.reSize.fontSize >= 22) {
          _this.reSize.fontSize = 22;
          _this.reSize.lageColor = '#B4B4B4';
        }
      }
    }

    // 是否能选择
    private isDis:boolean = false;

    // 倒计时
    private startTime: any = '';

    private endTime: any = '';

    private timer:any

    // 图标
    private icons:any = [obtainIcon1, obtainIcon2, obtainIcon3]

    // 是否显示结果
    private showResult:boolean = false;

    private back() {
      this.$router.go(-1);
    }

    // 学习文章id
    private docId:any = '';

    private title: any = '';


    // 文章题目
    private topicTitle:any = '';

    // button
    private buttonTitle:any = '';

    // 题目
    private topic:any = [];

    // 文章
    private article:any = [];

    // 音频
    private audio:any = {
      src: '',
      show: true,
    };

    // 答案
    private answer:any=[];

    // 计算已经答题数
    private answerNumber:number;

    // 是否已经提交答案
    private isSubmit = false;

    // 答题结束显示结果
    private result:any={};

    private unitId:any = ''

    private created() {
      if (this.$route.query) {
        this.docId = this.$route.query.docId;
        this.unitId = this.$route.query.unitId;
      } else {
        this.$router.go(-1);
      }
      this.setSkeletonDescribe(true);
      NProgress.start();
      this.init();
    }

    // 加载页面的方法
    private init() {
      this.queryUserAnalysisDocByDocId(this.docId).then((res: any) => {
        window.LS.set('readUnitData', res.data.data);
        this.title = window.LS.get('readData').courseName;
        const readUnitData = window.LS.get('readUnitData');
        this.topicTitle = readUnitData[readUnitData.length - 1].articleName;
        this.article = readUnitData[readUnitData.length - 1].articleContent;
        this.audio.src = readUnitData[readUnitData.length - 1].articleAudio;
        this.audioUrl = readUnitData[readUnitData.length - 1].articleAudio;
        this.$nextTick(() => {
          this.$refs.plyr.player.on('ready', () => {
            const obj:any = document.querySelectorAll('button.plyr__controls__item');
            for (const i in obj) {
              if (typeof obj[i] === 'object') {
                const dataplyr = obj[i].getAttribute('data-plyr');
                if (dataplyr == 'play') {
                  obj[i].click();
                }
              }
            }
          });
        });
        const topicObj = [];
        for (let i = 0; i < readUnitData.length; i++) {
          const item = readUnitData[i];
          for (let j = 0; j < item.questionVos.length; j++) {
            const questionVos = item.questionVos[j];
            for (let z = 0; z < questionVos.questionOptionVos.length; z++) {
              if (questionVos.questionOptionVos[z].optionid == questionVos.rightId) {
                questionVos.questionOptionVos[z].image = require('../../assets/images/word-yes.png');
              }
            }
            questionVos.questionTypeName = item.questionTypeName;
            topicObj.push(questionVos);
          }
        }

        this.topic = topicObj;
        console.log(this.topic);

        NProgress.done();
        this.setSkeletonDescribe(false);
      });
    }

    // 加载页面数据--请求数据
    private async queryUserAnalysisDocByDocId(ids) {
      const data = {
        docId: ids,
      };
      return await Read.queryUserAnalysisDocByDocId(data);
    }

    // 提交答案
    private submintAnswer() {
      this.$router.push({
        path: '/read/essayList',
        query: {
          unitId: this.unitId,
        },
      });
      // this.$router.go(-1);
    }

    // 弹窗
    private dialogHandle() {

    }

    // 播放读音
    private playAudio() {
      // this.loading = true;
      // this.playing = true;
      this.audio.show = false;
      // this.$refs.audio.src = this.audio.src;
      console.log(this.$refs.audio);
      this.$refs.audio.play();
    }

    // 暂停读音
    private stopAudio() {
      this.audio.show = true;
      // this.$refs.audio.currentTime = 0;
      this.$refs.audio.pause();
    }
}
